/**
 * Costanti e Configurazioni per il Progetto V!BRA People Care — Buenavista
 */

// Legenda delle Competenze Organizzative
export const COMPETENCY_LEGEND = [
    {
        id: 'distintivo',
        min: 3.25,
        max: 5.0,
        label: 'Punto di forza distintivo',
        bg: 'bg-sky-100',
        text: 'text-sky-800',
        border: 'border-sky-300',
        badgeClass: 'bg-sky-100 text-sky-800 border-sky-300'
    },
    {
        id: 'consolidata',
        min: 3.00,
        max: 3.24,
        label: 'Competenza consolidata',
        bg: 'bg-emerald-100',
        text: 'text-emerald-800',
        border: 'border-emerald-300',
        badgeClass: 'bg-emerald-100 text-emerald-800 border-emerald-300'
    },
    {
        id: 'presidio',
        min: 2.75,
        max: 2.99,
        label: 'Buon presidio',
        bg: 'bg-amber-100',
        text: 'text-amber-800',
        border: 'border-amber-300',
        badgeClass: 'bg-amber-100 text-amber-800 border-amber-300'
    },
    {
        id: 'consolidamento',
        min: 2.50,
        max: 2.74,
        label: 'Area di consolidamento',
        bg: 'bg-orange-100',
        text: 'text-orange-800',
        border: 'border-orange-300',
        badgeClass: 'bg-orange-100 text-orange-800 border-orange-300'
    },
    {
        id: 'sviluppo',
        min: 0,
        max: 2.49,
        label: 'Priorità di sviluppo',
        bg: 'bg-rose-100',
        text: 'text-rose-800',
        border: 'border-rose-300',
        badgeClass: 'bg-rose-100 text-rose-800 border-rose-300'
    }
];

export const getCompetencyBand = (score) => {
    if (score === null || score === undefined || score === '' || isNaN(Number(score))) {
        return null;
    }
    const num = Number(score);
    for (const band of COMPETENCY_LEGEND) {
        if (num >= band.min && (band.max === 5.0 ? num <= band.max : num <= band.max + 0.009)) {
            return band;
        }
    }
    if (num >= 3.25) return COMPETENCY_LEGEND[0];
    return COMPETENCY_LEGEND[4];
};

// Sezione A: Aree di Bisogno all'Inizio del Percorso (Multiselect)
export const SECTION_A_AREAS = [
    { id: 'benessere_personale', label: 'Benessere ed equilibrio personale', icon: '🧘' },
    { id: 'cambiamenti_personali_professionali', label: 'Cambiamenti personali o professionali', icon: '🔄' },
    { id: 'relazioni_comunicazione', label: 'Relazioni e comunicazione', icon: '💬' },
    { id: 'difficolta_incertezza', label: 'Situazioni di difficoltà o incertezza', icon: '🧭' },
    { id: 'scelte_decisioni', label: 'Scelte e decisioni', icon: '⚖️' },
    { id: 'consapevolezza_se', label: 'Consapevolezza e conoscenza di sé', icon: '🌱' },
    { id: 'valorizzazione_risorse', label: 'Valorizzazione delle mie risorse', icon: '✨' },
    { id: 'ruolo_professionale', label: 'Ruolo e vita professionale', icon: '💼' },
    { id: 'equilibrio_lavoro_vita', label: 'Equilibrio tra vita personale e lavoro', icon: '⚖️' }
];

// Sezione B: I 10 Indicatori di Autopercezione (Scala Likert 1-5, somministrati sia in IN che in OUT)
export const SECTION_B_ITEMS = [
    {
        id: 'item1',
        text: '1. Riesco a riconoscere ciò che provo e ciò di cui ho bisogno.',
        shortLabel: 'Riconoscimento bisogni & emozioni'
    },
    {
        id: 'item2',
        text: '2. Riesco a fare chiarezza quando mi trovo in una situazione di difficoltà o incertezza.',
        shortLabel: 'Chiarezza nelle difficoltà'
    },
    {
        id: 'item3',
        text: '3. Mi sento in grado di utilizzare le mie risorse personali per affrontare situazioni nuove o complesse.',
        shortLabel: 'Uso risorse per situazioni complesse'
    },
    {
        id: 'item4',
        text: '4. Riesco a gestire in modo efficace le mie emozioni nelle situazioni che vivo.',
        shortLabel: 'Gestione efficace emozioni'
    },
    {
        id: 'item5',
        text: '5. Mi sento capace di esprimere bisogni, opinioni e punti di vista nelle relazioni con gli altri.',
        shortLabel: 'Espressione bisogni nelle relazioni'
    },
    {
        id: 'item6',
        text: '6. Riesco ad adattarmi ai cambiamenti mantenendo un sufficiente senso di equilibrio.',
        shortLabel: 'Adattamento ai cambiamenti'
    },
    {
        id: 'item7',
        text: '7. Mi sento protagonista delle mie scelte e delle decisioni che mi riguardano.',
        shortLabel: 'Protagonismo nelle scelte'
    },
    {
        id: 'item8',
        text: '8. Complessivamente percepisco una condizione di benessere ed equilibrio nella mia vita attuale.',
        shortLabel: 'Benessere & equilibrio globale'
    },
    {
        id: 'item9',
        text: '9. Mi sento in grado di affrontare con sufficiente chiarezza i cambiamenti che riguardano la mia esperienza professionale.',
        shortLabel: 'Cambiamenti professionali'
    },
    {
        id: 'item10',
        text: '10. Riesco a riconoscere come le mie risorse personali possono essere utilizzate anche nel contesto lavorativo.',
        shortLabel: 'Risorse personali nel lavoro'
    }
];

export const LIKERT_OPTIONS = [
    { value: 1, label: '1 = per nulla' },
    { value: 2, label: '2 = poco' },
    { value: 3, label: '3 = abbastanza' },
    { value: 4, label: '4 = molto' },
    { value: 5, label: '5 = pienamente' }
];

// Ente predefinito di partenza
export const DEFAULT_BUENAVISTA_ORG = {
    id: 'buenavista',
    name: 'BuenaVista Cooperativa Sociale',
    shortName: 'BuenaVista',
    project: 'V!BRA People Care',
    projectPhase: 'Fase pilota Buenavista',
    defaultManager: 'Federica Ciabattari',
    managers: ['Federica Ciabattari'],
    meetingCount: 8,
    contactEmail: 'info@buenavistacoop.it',
    notes: 'Progetto di People Care e counseling organizzativo per il personale della cooperativa.'
};

// Counselor di sistema e abilitazioni predefinite
export const DEFAULT_SYSTEM_COUNSELORS = [
    {
        id: 'marilisa_admin',
        email: 'marilisa.delve@gmail.com',
        name: 'Marilisa Del Vecchio',
        role: 'admin',
        canOrganizational: true,
        specializations: ['individuale', 'organizzativo', 'people_care'],
        isActive: true
    },
    {
        id: 'marzia_m_counselor',
        email: 'marzia.macca@gmail.com',
        name: 'Marzia M.',
        role: 'org_admin',
        organizationId: 'buenavista',
        organizationName: 'BuenaVista Cooperativa Sociale',
        allowedOrganizations: ['buenavista'],
        canOrganizational: true,
        specializations: ['individuale', 'organizzativo', 'people_care'],
        isActive: true,
        authMethod: 'google'
    },
    {
        id: 'martina_vaccarone_counselor',
        email: 'martina@gmail.com',
        name: 'Martina Vaccarone',
        role: 'counselor',
        organizationId: 'buenavista',
        organizationName: 'BuenaVista Cooperativa Sociale',
        allowedOrganizations: ['buenavista'],
        canOrganizational: true,
        specializations: ['individuale', 'organizzativo', 'people_care'],
        isActive: true,
        authMethod: 'google'
    },
    {
        id: 'martina_trebino_counselor',
        email: 'trebino.martina@gmail.com',
        name: 'Martina Trebino',
        role: 'org_admin',
        organizationId: 'buenavista',
        organizationName: 'BuenaVista Cooperativa Sociale',
        allowedOrganizations: ['buenavista'],
        canOrganizational: true,
        specializations: ['individuale', 'organizzativo', 'people_care'],
        isActive: true,
        authMethod: 'google'
    },
    {
        id: 'patrizia_marforio_admin',
        email: 'patrizia.marforio@gmail.com',
        name: 'Patrizia Marforio',
        role: 'org_admin',
        organizationId: 'buenavista',
        organizationName: 'BuenaVista Cooperativa Sociale',
        allowedOrganizations: ['buenavista'],
        canOrganizational: true,
        specializations: ['organizzativo', 'people_care'],
        isActive: true,
        authMethod: 'google'
    },
    {
        id: 'patrizia_marchi_counselor',
        email: 'patrizia.marchi.1969@gmail.com',
        name: 'Patrizia Marchi',
        role: 'org_admin',
        organizationId: 'buenavista',
        organizationName: 'BuenaVista Cooperativa Sociale',
        allowedOrganizations: ['buenavista'],
        canOrganizational: true,
        specializations: ['individuale', 'organizzativo', 'people_care'],
        isActive: true,
        authMethod: 'google'
    }
];


